import api from '@/api';
import {
  // eslint-disable-next-line comma-dangle
  CONFLICT, NOT_ACCEPTABLE, NOT_FOUND, UNAUTHORIZED, UNPROCESSABLE_ENTITY
} from '../../enums/errorEnums';

const baseAPI = `${process.env.VUE_APP_BASE_API}/Companies`;
const HANDLED_ERRORS = [NOT_ACCEPTABLE, CONFLICT, UNPROCESSABLE_ENTITY, UNAUTHORIZED, NOT_FOUND];

const errorValidate = (response) => {
  let errors = null;
  const { status } = response;

  if (HANDLED_ERRORS.includes(status)) {
    errors = {
      status,
      statusText: response.statusText || response.data.message,
    };
  }

  return errors;
};

const applyFilters = (uri, key, value) => {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  }

  return `${uri + separator + key}=${value}`;
}

export default {
  register: async ({
    name, email, password, categoryId,
  }) => {
    const response = await api.post(`${baseAPI}`, {
      name,
      email: email.toLowerCase(),
      password,
      categoryId,
    });

    const errors = errorValidate(response);

    return {
      ...response,
      errors,
    };
  },
  getAll: async ({ includeJobs = false }) => {
    const baseUrl = applyFilters(`${baseAPI}`, 'includeJobs', includeJobs);

    const response = await api.get(baseUrl);

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  getMe: async ({ email = '' }) => {
    const response = await api.get(`${baseAPI}/me`, { params: { email } });

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  getById: async (companyId, { includeJobs = false }) => {
    const baseUrl = applyFilters(`${baseAPI}/${companyId}`, 'includeJobs', includeJobs);

    const response = await api.get(baseUrl);

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
  updateProfile: async ({ payload }) => {
    const response = await api.put(`${baseAPI}`, payload);

    const errors = errorValidate(response);

    const { data } = response;

    return {
      data,
      errors,
    };
  },
};
